document.addEventListener('DOMContentLoaded',()=>{const root=document.querySelector('.hx14-page');if(!root)return;const hero=root.querySelector('[data-hx14-hero]');root.querySelectorAll('.hx14-thumb').forEach(b=>b.addEventListener('click',()=>{root.querySelectorAll('.hx14-thumb').forEach(x=>x.classList.remove('active'));b.classList.add('active');if(hero)hero.src=b.dataset.src;}));root.querySelectorAll('.hx14-offer').forEach(b=>b.addEventListener('click',()=>{root.querySelectorAll('.hx14-offer').forEach(x=>x.classList.remove('selected'));b.classList.add('selected');const q=root.querySelector('[data-hx14-quantity]');if(q)q.value=b.dataset.qty||'1';}));root.querySelectorAll('.hx14-mode').forEach(b=>b.addEventListener('click',()=>{root.querySelectorAll('.hx14-mode').forEach(x=>x.classList.remove('selected'));b.classList.add('selected');}));root.querySelectorAll('.hx14-faq-item>button').forEach(b=>b.addEventListener('click',()=>{const item=b.parentElement;item.classList.toggle('open');const i=b.querySelector('i');if(i)i.textContent=item.classList.contains('open')?'−':'+';}));});

/* PERFORMAX live delivery estimate — visitor-local date.
   Intervals intentionally match the supplied reference:
   order today -> prepared +1 day -> delivery +2 to +3 days. */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-hv-delivery-estimate]').forEach((estimate) => {
    const monthNamesTN = [
      'جانفي','فيفري','مارس','أفريل','ماي','جوان',
      'جويلية','أوت','سبتمبر','أكتوبر','نوفمبر','ديسمبر'
    ];

    const startOfLocalDay = (date) => new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      12, 0, 0, 0
    );

    const addDays = (date, days) => {
      const next = new Date(date);
      next.setDate(next.getDate() + days);
      return next;
    };

    const formatTN = (date) => `${date.getDate()} ${monthNamesTN[date.getMonth()]}`;

    const today = startOfLocalDay(new Date());
    const ready = addDays(today, 1);
    const arrivalStart = addDays(today, 2);
    const arrivalEnd = addDays(today, 3);

    const todayEl = estimate.querySelector('[data-hv-delivery-today]');
    const readyEl = estimate.querySelector('[data-hv-delivery-ready]');
    const arriveEl = estimate.querySelector('[data-hv-delivery-arrive]');

    if (todayEl) todayEl.textContent = formatTN(today);
    if (readyEl) readyEl.textContent = formatTN(ready);
    if (arriveEl) arriveEl.textContent = `${formatTN(arrivalStart)} - ${formatTN(arrivalEnd)}`;
  });
});

/* PERFORMAX V9 — gallery arrows support every configured gallery slot. */
document.addEventListener('DOMContentLoaded',()=>{
  const root=document.querySelector('.hx14-page');
  if(!root)return;
  const wrap=root.querySelector('.hx14-thumbs');
  if(!wrap)return;
  const thumbArrows=[...wrap.querySelectorAll('.hx14-arrow')];
  const overlayPrev=root.querySelector('[data-hx14-gallery-prev]');
  const overlayNext=root.querySelector('[data-hx14-gallery-next]');
  const thumbs=[...wrap.querySelectorAll('.hx14-thumb')];
  if(thumbs.length<2)return;
  const move=(delta)=>{
    let idx=thumbs.findIndex((thumb)=>thumb.classList.contains('active'));
    if(idx<0)idx=0;
    idx=(idx+delta+thumbs.length)%thumbs.length;
    thumbs[idx].click();
    thumbs[idx].scrollIntoView({behavior:'smooth',block:'nearest',inline:'nearest'});
  };
  if(thumbArrows.length>=2){
    thumbArrows[0].addEventListener('click',()=>move(-1));
    thumbArrows[thumbArrows.length-1].addEventListener('click',()=>move(1));
  }
  if(overlayPrev)overlayPrev.addEventListener('click',()=>move(-1));
  if(overlayNext)overlayNext.addEventListener('click',()=>move(1));
});


/* PERFORMAX V19 — MOBILE CENTERED THUMBNAIL CAROUSEL
   Keeps the thumbnail for the currently displayed product image centered
   after arrow navigation or a direct thumbnail tap. */
document.addEventListener('DOMContentLoaded',()=>{
  const root=document.querySelector('.hx14-page');
  if(!root)return;
  const strip=root.querySelector('.hx14-thumbs');
  if(!strip)return;
  const thumbs=[...strip.querySelectorAll('.hx14-thumb')];
  if(!thumbs.length)return;

  const centerThumb=(thumb,behavior='smooth')=>{
    if(!thumb)return;
    // requestAnimationFrame lets the active class/image update land first.
    requestAnimationFrame(()=>{
      const stripRect=strip.getBoundingClientRect();
      const thumbRect=thumb.getBoundingClientRect();
      const current=strip.scrollLeft;
      const delta=(thumbRect.left + thumbRect.width/2) - (stripRect.left + stripRect.width/2);
      strip.scrollTo({left:current + delta,behavior});
    });
  };

  thumbs.forEach((thumb)=>{
    thumb.addEventListener('click',()=>centerThumb(thumb));
  });

  const prev=root.querySelector('[data-hx14-gallery-prev]');
  const next=root.querySelector('[data-hx14-gallery-next]');
  [prev,next].forEach((btn)=>{
    if(!btn)return;
    btn.addEventListener('click',()=>{
      requestAnimationFrame(()=>{
        const active=strip.querySelector('.hx14-thumb.active');
        centerThumb(active);
      });
    });
  });

  // Center the initially active thumbnail on mobile after layout is ready.
  if(window.matchMedia('(max-width: 640px)').matches){
    window.setTimeout(()=>centerThumb(strip.querySelector('.hx14-thumb.active'),'auto'),80);
  }
});
